module.exports = __webpack_public_path__ + "img/loyalty_pop.fbf5a7fd.jpg";